import React from 'react';
import { Box, Typography, Button, Container, useTheme } from '@mui/material';


const sections = [
    {
        bgColor: 'rgba(255, 255, 255, 0.7)',
        clip: 'polygon(0 0, 100% 5%, 100% 100%, 0 95%)',

        description: `BioPhy’s solutions help regulatory, quality, and operations teams navigate complex requirements and documentation at speed. BioPhy’s regulatory research engine enables teams to rapidly locate, synthesize, and operationalize regulatory and scientific information across authoritative sources and internal knowledge, supporting faster answers to critical compliance questions and reducing time spent on manual research.<br /><br />
       In addition, BioPhy offers a QMS gap analysis solution that helps organizations assess alignment between current SOPs, quality documentation, and applicable requirements. By identifying gaps and prioritizing remediation opportunities, the solution is designed to help teams strengthen inspection readiness and continuously improve quality processes.`,
        showButton: false,
    },
    {
        image: '/insightsgrid.png',
        bgColor: 'rgba(233, 237, 110, 0.2)',
        clip: 'polygon(0 5%, 100% 0, 100% 95%, 0 100%)',
        
        title: 'FEATURES & BENEFITS',
        paragraphs: [
            <>
                <strong>SOP Harmonization</strong> – Surfaces document duplication across departments and regions and consolidates document drafting.
            </>,
            <>
                <strong>Quality Compliance Efficiencies</strong> –  Reduces manual review by 85%. Identifies misalignments between SOPs and regulations automatically. Offers compliance risk scoring and remediation recommendations.
            </>,
            <>
                <strong>30% Better Accuracy</strong> – BioPhy's hybrid engine consistently outperforms open source LLM methods in identifying regulatory gaps, without months of fine-tuning and maintenance.
            </>,
            <>
                <strong>Enterprise-Ready Scalability</strong> – BioPhy is already deployed on GPU-backed infrastructure sized for billion vector indexes. No $35M capex, no six-month H100 lead times, no rate limits.
            </>,
            <>
                <strong>Rapid Results</strong> – Continuous monitoring flags new gaps within hours of any SOP or regulatory revision, turning weeks of clerical work into a dashboard refresh.
            </>,
            <>
                <strong>Stay Focused on Core Science Work</strong> – our data science team stays on mission with patient impact work instead of wrangling front-end state management or validation paperwork.
            </>,
            <>
                <strong>Version Control Intelligence</strong> – Surfaces the most recent, authoritative versions of SOPs, flagging outdated or unapproved drafts to prevent accidental use of incorrect procedures.
            </>
        ],

    },
    {
        bgColor: 'rgba(255, 255, 255, 0.7)',
        clip: 'polygon(0 0, 100% 5%, 100% 100%, 0 95%)',
        title: 'READY TO SEE MORE?',
        image1: true,


        showButton: true,
    },
];

const BiophyServiceSection = () => {
    //  const [showVideo, setShowVideo] = useState(false);
    const theme = useTheme();
    //const headingColor = theme.palette.mode === 'light' ? '#9e9e9e' : '#797373ff';

    return (
        <>
            <Box sx={{ py: 2, px: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography

                    sx={{
                        fontWeight: 'bold',
                        color: theme.palette.mode === "dark" ? "white" : "black",
                        fontSize: '1.5rem',
                        mb: 2,
                    }}
                >
                    INTRINSIC BIOPHY
                </Typography>
                <Typography
                    variant="h4"
                    sx={{
                        mb: 2,
                        fontSize: '1.2rem',
                        textAlign: 'center',
                        maxWidth: '800px',
                    }}
                >
                    Transforming Operations with AI
                </Typography>




                {/* <img
                        src="/biophyimage.png"
                        alt="Click to play"

                        style={{
                            cursor: 'pointer',
                            borderRadius: '12px',
                         
                            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                            width: '50%',
                            height: '300px',
                        }}
                    /> */}




            </Box>

            {sections.map((section, index) => (
                <Box
                    key={index}
                    sx={{
                        backgroundColor: section.bgColor,
                        clipPath: {
                            xs: 'none', // remove clipPath on small screens to prevent text cutting
                            md:
                                index % 2 === 0
                                    ? 'polygon(0 0, 100% 20%, 100% 100%, 0 80%)'
                                    : 'polygon(0 20%, 100% 0, 100% 80%, 0 100%)',
                        },
                        position: 'relative',
                        zIndex: 10 - index,
                        mt: index === 0 ? 0 : { xs: 0, md: '-80px' }, // remove negative margin for xs
                        py: { xs: 8, md: 12 }, // reduce vertical padding for small screens
                        px: { xs: 2, md: 6 },
                        borderRadius: { xs: 2, md: 0 }, // optional: rounded edges for small screens
                    }}
                >
                    <Container>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: {
                                    xs: 'column', // stack content vertically on small screens
                                    md: index % 2 === 0 ? 'row' : 'row-reverse',
                                },
                                alignItems: 'center',
                                gap: 4,
                            }}
                        >
                            <Box
                                sx={{
                                    flex: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textAlign: 'left',
                                    px: { xs: 1, md: 12 }, // reduce padding on small screens
                                    overflow: 'hidden', // prevent text from overflowing
                                }}
                            >

                                {section.image1 && (
                                    <img
                                        src="/biophyimage.png"
                                        alt="Click to play"

                                        style={{
                                            cursor: 'pointer',
                                            borderRadius: '12px',

                                            boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                                            width: '30%',
                                            height: '150px',
                                        }}
                                    />)
                                }

                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontWeight: 'bold',
                                        color: theme.palette.mode === 'dark' ? 'white' : 'black',
                                        mb: 4,
                                        fontSize: { xs: '1.3rem', md: '1.5rem' }, // responsive font size
                                    }}
                                >
                                    {section.title}
                                </Typography>

                                {section.showButton && (
                                    <Button
                                        variant="contained"
                                        href="https://www.biophy.ai/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{
                                            backgroundColor: '#e9c71f',
                                            color: '#FFFFFF',
                                            px: '40px',
                                            py: '6px',
                                            fontSize: '1.4rem',
                                            borderRadius: '50px',
                                            textTransform: 'none',
                                            fontWeight: 500,
                                            boxShadow: '0px 4px 12px rgba(0, 174, 239, 0.4)',
                                            transition: 'transform 0.3s ease, background-color 0.3s ease',
                                            '&:hover': {
                                                backgroundColor: '#0081cc',
                                                transform: 'scale(1.05)',
                                            },
                                        }}
                                    >
                                        Explore BioPhy
                                    </Button>

                                )}

                                {section.paragraphs
                                    ? section.paragraphs.map((para, idx) => (
                                        <Typography
                                            key={idx}
                                            variant="body1"
                                            sx={{
                                                mb: 2,
                                                textAlign: 'justify',
                                                fontSize: { xs: '0.9rem', md: '1rem' },
                                                fontFamily: 'Montserrat, sans-serif',
                                                px: { xs: 1, md: 4 }
                                            }}
                                        >
                                            {para}
                                        </Typography>
                                    ))
                                    : (
                                        <Typography
                                            variant="body1"
                                            sx={{ mb: section.showButton ? 4 : 0, textAlign: 'justify', px: { xs: 1, md: 4 } }}
                                            dangerouslySetInnerHTML={{ __html: section.description }}
                                        />

                                    )}
                            </Box>
                        </Box>
                    </Container>
                </Box>
            ))}

        </>
    );
};

export default BiophyServiceSection;


